// Event Categories
export const APP_MARKETPLACE_EVENT_CATEGORY = 'app-marketplace';
export const APP_REVIEW_EVENT_CATEGORY = 'app-reviews';


// Event Actions
export const HOME_PAGE_APP_CLICK = 'HomepageAppClick';
export const HOME_PAGE_SPOTLIGHT_CLICK = 'HomepageSpotlightClick';

export const PRODUCT_PAGE_SCREENSHOT_CLICK = 'ScreenshotClick';
export const PRODUCT_PAGE_READ_MORE_CLICK = 'ReadmoreClick';
export const PRODUCT_PAGE_SUPPORT_CLICK = 'SupportClick';
export const PRODUCT_PAGE_RESOURCE_CLICK = 'ResourceClick';
export const PRODUCT_PAGE_CTA_CLICK = 'CtaClick';

export const CAT_PAGE_APP_CLICK = 'CatAppClick';

export const SEARCH_PAGE_APP_CLICK = 'SearchAppClick';

export const CATEGORY_BAR_CLICK = 'CategoryBarClick';
export const CATEGORY_CARD_CLICK = 'CategoryCardClick';

export const APP_REPLY_CLICK = 'AppReplyClicked';
export const APP_REPLY_CREATED = 'AppReplyCreated';
export const APP_REPLY_EDITED = 'AppReplyEdited';
export const APP_REPLY_DELETED = 'AppReplyDeleted';

export const APP_RATING_CLICKED = 'AppRatingClicked';
export const APP_RATING_CREATED = 'AppRatingCreated';
export const APP_RATING_UPDATED = 'AppRatingUpdated';


// WEBPACK FOOTER //
// ./src/constants/analytics.js